<template>
  <router-view v-model="mountingTimeslot" />
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useFetchQuery } from '@hooks/fetch';
import { syncHeader } from '@components/structure/navigation/injects';
import { syncPageBusy } from '@utils/busy/injects';
import { format } from 'date-fns';
import type { Mounting, MountingTimeslot } from '@/entities/Entities';

interface Props {
  modelValue: Mounting | null;
}

const props = defineProps<Props>();

const route = useRoute();
const { data: mountingTimeslot, loading } = useFetchQuery<MountingTimeslot>(
  `/mounting_timeslots/${route.params.mountingTimeslotId}`,
);

syncPageBusy(loading);

const title = computed(() => `${mountingTimeslot.value?.startTime ? format(new Date(mountingTimeslot.value?.startTime), 'dd.MM.yyyy - HH:mm:ss') : ''}`);
const mountingTitle = computed(() => `${props.modelValue?.address}`);

syncHeader(
  mountingTimeslot,
  (newMountingTimeslot) => ({
    extraBreadcrumbs: [
      computed(() => ({
        label: title.value,
        link: `/mountings/${mountingTimeslot.value?.mounting?.id}/timeslots/${mountingTimeslot.value?.id}`,
      })),
    ],
    title: computed(() => ({
      text: title.value,
      link: { name: 'mounting-timeslots-active', params: { mountingId: mountingTimeslot.value?.mounting?.id } },
    })),
  }),
);
</script>

<style lang="scss" scoped></style>
